export default __webpack_public_path__ + "static/media/blank.c83b550c.png";